import cloneDeep from 'lodash/cloneDeep';

import { Project } from 'src/store/state/projects';

export const duplicateProject = (
  project: Project,
  newProperties: Required<Pick<Project, 'id' | 'dateCreated'>> &
    Partial<Project>
): Project => ({
  ...cloneDeep(project),
  dateLastUpdated: newProperties.dateCreated,
  ...newProperties,
});
